/**
 * Dashboard Data Hooks
 *
 * React Query hooks for dashboard KPIs.
 * @see Sprint 28 - US-28.2
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';

const STALE_TIME = 2 * 60 * 1000; // 2 minutes

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stockKpis: () => [...dashboardKeys.all, 'stockKpis'] as const,
  lossKpis: () => [...dashboardKeys.all, 'lossKpis'] as const,
  lastInventory: () => [...dashboardKeys.all, 'lastInventory'] as const,
};

export function useStockKPIs() {
  return useQuery({
    queryKey: dashboardKeys.stockKpis(),
    queryFn: () => dashboardService.getStockKPIs(),
    staleTime: STALE_TIME,
    placeholderData: (prev) => prev,
  });
}

export function useLossKPIs() {
  return useQuery({
    queryKey: dashboardKeys.lossKpis(),
    queryFn: () => dashboardService.getLossKPIs(),
    staleTime: STALE_TIME,
    placeholderData: (prev) => prev,
  });
}

export function useLastInventory() {
  return useQuery({
    queryKey: dashboardKeys.lastInventory(),
    queryFn: async () => {
      const result = await dashboardService.getLastValidatedInventory();
      return result.data[0] ?? null;
    },
    staleTime: STALE_TIME,
    placeholderData: (prev) => prev,
  });
}
